export default "__VITE_ASSET__CK098$fB__"